export default class BuyButtons extends Core.Component {
  onMount() {
    const dynamicCheckoutBtnEl = this.el.querySelector('[data-shopify="payment-button"]');

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    if (dynamicCheckoutBtnEl && !dynamicCheckoutBtnEl.classList.contains('.shopify-payment-button__button--hidden')) {
      const btn = this.query('button-action');

      btn.style = 'secondary';
    }

    this.events.register(this.el, 'submit', e => {
      e.preventDefault();

      const btn = this.query('button-action');
      const notifications = this.queryAll('notification');
      const recipientForm = this.el.querySelector('[data-recipient-form]');

      btn.loading = true;

      fetch(
        `${window.PXUTheme.routes.cart_add_url}.js`,
        {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(e.target),
        },
      )
        .then(response => (
          Promise.all([
            response,
            fetch(
              `${window.PXUTheme.routes.cart_url}.js`,
              {
                method: 'GET',
                headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              },
            ),
          ])
        ))
        .then(([response1, response2]) => Promise.all([response1.json(), response2.json()]))
        .then(([response, cart]) => {
          if (response.status) {
            const addToCartErrorEvent = new CustomEvent('product:add-to-cart:error', { detail: { cart, error: response }, bubbles: true });
            this.el.dispatchEvent(addToCartErrorEvent);

            notifications.forEach(notification => {
              notification.type = 'error';
              if (response.description.email) {
                notifications[0].hidden = false;
              } else {
                notification.content = response.description;
                notification.hidden = false;
              }
            });

            if (response.description.email) {
              recipientForm.classList.add('recipient-form--errors');
            }

            return;
          }

          if (recipientForm) {
            recipientForm.classList.remove('recipient-form--errors');

            notifications.forEach(notification => {
              notification.hidden = true;
            });
          }

          if (window.location.pathname === '/cart') {
            window.location.reload();
            return;
          }

          const addToCartEvent = new CustomEvent('product:add-to-cart:success', { detail: { cart, line_item: response }, bubbles: true });
          this.el.dispatchEvent(addToCartEvent);

          const cartDrawer = Core.Components.getComponent('cart-drawer');

          if (cartDrawer && cartDrawer.data.enabled) {
            cartDrawer.open(btn.el, true, [response]);
          } else {
            window.location = window.PXUTheme.routes.cart_url;
          }
        })
        .catch(err => console.error('Error:', err))
        .finally(() => { btn.loading = false; });
    });
  }

  setButtonState(state) {
    const btn = this.query('button-action');
    switch(state) {
      case 'unavailable':
        btn.el.innerHTML = this.data.unavailable;
        btn.el.setAttribute('disabled', '');
        break;
      case 'sold out':
        btn.el.innerHTML = this.data.soldOut;
        btn.el.setAttribute('disabled', '');
        break;
      case 'available':
        btn.el.innerHTML = this.data.addToCart;
        btn.el.removeAttribute('disabled');
    }
  }
}
